module.exports = __webpack_public_path__ + "static/media/desktop-alt.3a7a1585.svg";